import { CommonModule } from '@angular/common';
import { Component, computed, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@jsverse/transloco';
import { AgGridModule, ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { PrismProgressIndicatorComponent } from '@shure/prism-angular-components';
import { PrismIconComponent } from '@shure/prism-angular-components';
import { DeviceStatus } from '@shure/shared/angular/data-access/system-api/models';

export interface DeviceStatusCellData {
	status: DeviceStatus;
	virtual: boolean;
}

export type NetworkRendererComponentParams = ICellRendererParams<object, DeviceStatusCellData>;

@Component({
	selector: 'sh-network-renderer',
	standalone: true,
	imports: [
		CommonModule,
		AgGridModule,
		MatIconModule,
		MatTooltipModule,
		PrismProgressIndicatorComponent,
		PrismIconComponent,
		TranslocoModule
	],
	templateUrl: './network-renderer.component.html',
	styleUrl: './network-renderer.component.scss'
})
export class NetworkRendererComponent implements ICellRendererAngularComp {
	public readonly data = signal<DeviceStatusCellData | null | undefined>(undefined);
	public readonly isOffline = computed(
		() => this.data()?.status === DeviceStatus.Offline || this.data()?.virtual === true
	);
	public readonly isOnline = computed(
		() => this.data()?.status === DeviceStatus.Online && this.data()?.virtual === false
	);
	public readonly isDiscovering = computed(() => this.data()?.status === DeviceStatus.Discovered);
	public readonly isError = computed(() => this.data()?.status === DeviceStatus.Error);

	public params!: NetworkRendererComponentParams;

	public agInit(params: NetworkRendererComponentParams): void {
		this.update(params);
	}

	public refresh(params: NetworkRendererComponentParams): boolean {
		this.update(params);
		return true;
	}

	private update(params: NetworkRendererComponentParams): void {
		this.params = params;
		this.data.set(params.value);
	}
}
